export default __webpack_public_path__ + "static/media/Sello.6029c2cc.png";